import React, { useState, useEffect } from 'react'
import { Panel, Message, Button } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import SearchLawForm from '../saveLawTracking/SearchLawForm'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import SearchLawResultTable from '../saveLawTracking/SearchLawResultTable'
import LitigationView from '../saveLawTracking/LitigationView'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import {
  approvedDocumentOfTerminate,
  getDocumentOfTerminateByid,
  saveDocumentOfTerminate,
  searchDocumentOfTerminate,
  sendRequestApproveDocumentOfTerminate,
} from '../../redux/actions/documentOfTermination'
import DocumentOfTerminationForm from './DocumentOfTerminationForm'
import { SAVE_ERR_MSG } from '../../constants/msgText'
import {
  downloadEcontractFile,
  downloadLitigationFileByPath,
  getLitigationFile,
} from '../../redux/actions/legal'
import { downloadFile, previewFile } from '../../utils/fileUtil'

export default function DocumentOfTerminationWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [searchResult, setSearchResult] = useState()
  const [searchLawData, setSearchLawData] = useState(null)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [litigationId, setLitigationId] = useState(null)
  const [errorMsg, setErrorMsg] = useState()
  const [clearValue, setClearValue] = useState(false)
  const [selectRowData, setSelectRowData] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [docTypeValue, setDocTypeValue] = useState(0)
  const [submitApprove, setSubmitApprove] = useState()

  const [requestApproveReq, setRequestApproveReq] = useState()
  const [isShowConfirmRequest, setIsShowConfirmRequest] = useState(false)

  useEffect(() => {
    // console.log('litigationId : ', projectId)
    projectId != 'menu' && getDocOfTerminate(projectId, '')
  }, [])

  useEffect(() => {
    if (formSchema?.form?.searchResult) {
      setSearchResult(formSchema?.form?.searchResult)
    }
  }, [formSchema])

  const getDocOfTerminate = async (litigationId, noticeId) => {
    setIsLoading(true)
    startLoading()

    try {
      //setSearchLawData(null)
      const response = await getDocumentOfTerminateByid(litigationId, noticeId)
      console.log('ress pose ', response)
      setDocTypeValue(response?.inputForm?.docType?.value || 0)
      setSearchLawData(response)
      setLitigationId(response?.litigationId || response.litigationInfo.id || '')
    } catch (error) {
      console.error(error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSearchLitagation = async (request) => {
    setIsLoading(true)
    startLoading()
    setErrorMsg(null)
    try {
      // console.log('onSearchLitagation : ', request)
      const response = await searchDocumentOfTerminate(request)
      setSearchResult(response)
      //setSearchLawData(response)
    } catch (error) {
      console.error(error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = async (data) => {
    // console.log('data', data)

    const formData = new FormData()

    data.file &&
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })

    formData.append('Id', searchLawData.id || '')
    formData.append('TerminateType', data.docType)
    formData.append('IsRequestApprove', false)
    formData.append('Note', data.detail || '')
    formData.append('InfomaNo', data.infomaNo || '')

    formData.append('DeleteFileIds', data.deleteFileIds || [])

    handleSaveNotice(formData, false)
  }

  // const onSubmitRequest = async (data) => {
  //   console.log('data', data)

  //   const formData = new FormData()

  //   data.file &&
  //     data.file?.forEach((element) => {
  //       formData.append('Files', element.blobFile)
  //     })

  //   formData.append('Id', searchLawData.id || '')
  //   formData.append('TerminateType', data.docType)
  //   formData.append('IsRequestApprove', true)
  //   formData.append('Note', data.detail || '')

  //   formData.append('DeleteFileIds', data.deleteFileIds || [])

  //   setIsShowConfirmRequest(true)
  //   setRequestApproveReq(formData)
  // }

  const handleSaveNotice = async (request, isRequestApprove) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveDocumentOfTerminate(request, litigationId)
      // console.log('response ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setErrorMsg(null)

        if (isRequestApprove) {
          setValueNullField()
          setSearchLawData(null)
          setIsShowConfirm(false)
          handleGetSchemaOnReload(5, 1)
        } else {
          setSearchLawData(null)
          setDocTypeValue(response?.inputForm?.docType?.value || 0)
          setSearchLawData(response)
          setLitigationId(response?.litigationId || response.litigationInfo.id || '')
        }
      } else {
        setErrorMsg({ type: 'error', description: response?.errorMessage })
      }
    } catch (error) {
      // console.error(error)

      notification.open('error', {
        title: error?.response?.data?.errors?.message || SAVE_ERR_MSG,
        duration: 10000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSaveRequestApprove = async (terminateId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await sendRequestApproveDocumentOfTerminate(litigationId, terminateId)
      // console.log('response ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setErrorMsg(null)
        setValueNullField()
        setSearchLawData(null)
        setIsShowConfirm(false)
        handleGetSchemaOnReload(5, 1)
      } else {
        setErrorMsg({ type: 'error', description: response?.errorMessage })
      }
    } catch (error) {
      // console.error(error)

      notification.open('error', {
        title: error?.response?.data?.errors?.message || SAVE_ERR_MSG,
        duration: 5000,
      })
    }

    setIsShowConfirmRequest(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleApproveNotice = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await approvedDocumentOfTerminate(litigationId, request)
      // console.log('response ', response)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
        setErrorMsg(null)
        setValueNullField()
        setSearchLawData(null)
        handleGetSchemaOnReload(5, 1)
      } else {
        setErrorMsg({ type: 'error', description: response?.errorMessage })
      }
    } catch (error) {
      // console.error(error)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || SAVE_ERR_MSG,
        duration: 5000,
      })
    }

    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onCancelSearchLitigation = () => {
    setSearchLawData(null)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      if (key == 'lawStatus' || key == 'limitation' || key == 'noteOfTracking' || key == 'file') {
        setValue(key, null)
      }
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  const handleGetSchemaOnReload = async (pagesize, pagenumber) => {
    const request = {
      lawType: getValues('lawType'),
      litigationName: getValues('litigationName'),
      projectCode: getValues('projectCode'),
      docNumberOfPurchase: getValues('docNumberOfPurchase'),
      contractNumberRef: getValues('contractNumberRef'),
      lawStatus: getValues('lawStatus'),
      lawStatus: getValues('lawStatus'),
      projectName: getValues('projectName'),
      department: getValues('department'),
      pageNumber: pagenumber || 1,
      pageSize: pagesize || 5,
    }

    onSearchLitagation(request)
  }

  const handleOnSelectRowData = (rowData) => {
    //console.log('rowData', rowData)
    sessionStorage.setItem('projectId', rowData.litigationId)

    setSelectRowData(rowData)
    getDocOfTerminate(rowData.litigationId, rowData.litigationTerminateId || '')
  }

  const handlerOnChangeDocType = (value) => {
    //console.log('handlerOnChangeDocType ', value)
    setDocTypeValue(value)
  }

  const onSubmitApprove = (data) => {
    //console.log('onSubmitApprove ', data)
    const request = {
      id: searchLawData.id,
      approveType: 1,
      comment: data.approveComment,
    }

    if (searchLawData?.inputForm?.buttonText?.approveButtonName) {
      setIsShowConfirm(true)
      setSubmitApprove(request)
    } else {
      handleApproveNotice(request)
    }
  }

  const onSubmitReject = (data) => {
    //console.log('onSubmitReject ', data)
    const request = {
      id: searchLawData.id,
      approveType: 2,
      comment: data.approveComment,
    }

    setIsShowConfirm(true)
    setSubmitApprove(request)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getLitigationFile(fileObj.id)

      downloadFile(file, fileObj.name)
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getLitigationFile(fileObj.id)

      previewFile(file, fileObj.name)
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownloadTermidate = async (code, econtractId, pathFile) => {
    if (econtractId) {
      handleDownloadEContractFile(code, econtractId)
    } else {
      onDownloadTermidateFile(pathFile)
    }
  }

  const onDownloadTermidateFile = async (pathFile) => {
    startLoading()

    try {
      var file = await downloadLitigationFileByPath(pathFile)
      var names = pathFile?.split('/')
      downloadFile(file, names[names.length - 1])
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDownloadEContractFile = async (code, econtractId) => {
    startLoading()
    setIsLoading(true)
    try {
      var fileName = `ลงนาม_หน้งสือบอกเลิก_${code}.pdf`

      var file = await downloadEcontractFile(econtractId)

      downloadFile(file, fileName)
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded bordered>
        {formSchema.form.searchForm && !searchLawData && (
          <SearchLawForm
            schema={formSchema.form.searchForm}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onSubmitData={onSearchLitagation}
            onCancelData={onSearchLitagation}
            PanelExpanded={projectId != 'menu'}
          />
        )}

        {searchResult && !searchLawData && (
          <div style={{ marginTop: 20 }}>
            <SearchLawResultTable
              schema={searchResult}
              pagination={true}
              loading={isLoading}
              onReload={handleGetSchemaOnReload}
              onSelect={handleOnSelectRowData}
              onDownload={onDownloadTermidate}
            />
          </div>
        )}

        {searchLawData?.litigationInfo && <LitigationView schema={searchLawData?.litigationInfo} />}

        {searchLawData?.inputForm && (
          <>
            <DocumentOfTerminationForm
              schema={searchLawData}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              onChangeDocType={handlerOnChangeDocType}
              // active={active}
              // onSubmitData={handleSubmit(onSubmitSaveLegalManagement)}
              onDownload={onDownload}
              onPreview={onPreview}
            />

            {isLoading && <OverlayLoader />}

            {searchLawData.inputForm && <hr />}

            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}

            {searchLawData.inputForm && (
              <>
                {searchLawData?.inputForm?.isApproveLevel ? (
                  <>
                    {searchLawData?.inputForm?.buttonText?.saveButtonName && (
                      <SaveButton
                        disabled={searchLawData?.disabled}
                        onClick={handleSubmit(onSubmitApprove)}
                      >
                        {searchLawData?.inputForm?.buttonText?.saveButtonName || ''}
                      </SaveButton>
                    )}

                    {searchLawData?.inputForm?.buttonText?.approveButtonName && (
                      <>
                        <Button
                          disabled={searchLawData?.disabled}
                          onClick={handleSubmit(onSubmitReject)}
                          appearance="primary"
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                        >
                          {searchLawData?.inputForm?.buttonText?.approveButtonName || ''}
                        </Button>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {searchLawData?.inputForm?.buttonText?.saveButtonName && (
                      <SaveButton
                        disabled={searchLawData?.disabled}
                        onClick={handleSubmit(onSubmit)}
                      >
                        {searchLawData?.inputForm?.buttonText?.saveButtonName || ''}
                      </SaveButton>
                    )}

                    {searchLawData?.inputForm?.buttonText?.approveButtonName && (
                      //docTypeValue != 0 &&
                      <>
                        <Button
                          disabled={searchLawData?.disabled || !searchLawData.id}
                          // onClick={handleSubmit(onSubmitRequest)}
                          onClick={() => {
                            setIsShowConfirmRequest(true)
                          }}
                          appearance="primary"
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                        >
                          {searchLawData?.inputForm?.buttonText?.approveButtonName || ''}
                        </Button>
                      </>
                    )}
                  </>
                )}

                {searchLawData?.inputForm?.buttonText?.cancelButtonName && (
                  <>
                    <CancelButton
                      //disabled={searchLawData?.inputForm?.buttonText?.disabled}
                      onClick={() => {
                        setSearchLawData(null)
                        onCancelSearchLitigation()
                        setValueNullField()
                        setSelectRowData(null)
                        sessionStorage.setItem('projectId', 'menu')
                      }}
                    >
                      {searchLawData?.inputForm?.buttonText?.cancelButtonName || ''}
                    </CancelButton>
                  </>
                )}

                <ConfirmWidget
                  title={
                    'ยืนยัน' +
                    (submitApprove?.approveType == 1
                      ? 'อนุม้ติ'
                      : searchLawData?.inputForm?.buttonText?.approveButtonName)
                  }
                  show={isShowConfirm}
                  detail={
                    'ยืนยัน' +
                    (submitApprove?.approveType == 1
                      ? 'อนุม้ติ'
                      : searchLawData?.inputForm?.buttonText?.approveButtonName)
                  }
                  onCancle={() => setIsShowConfirm(false)}
                  onConfirm={() => {
                    setIsShowConfirm(false)
                    handleApproveNotice(submitApprove)
                  }}
                />

                <ConfirmWidget
                  title={'ยืนยัน' + searchLawData?.inputForm?.buttonText?.approveButtonName}
                  show={isShowConfirmRequest}
                  detail={'ยืนยัน' + searchLawData?.inputForm?.buttonText?.approveButtonName}
                  onCancle={() => setIsShowConfirmRequest(false)}
                  onConfirm={() => {
                    setIsShowConfirmRequest(false)
                    handleSaveRequestApprove(searchLawData.id)
                    //handleSaveNotice(requestApproveReq, true)
                  }}
                />
              </>
            )}
          </>
        )}
      </Panel>
    </>
  )
}
